import { render, staticRenderFns } from "./classTeacher.vue?vue&type=template&id=eb9ee6f0&scoped=true"
import script from "./classTeacher.vue?vue&type=script&lang=js"
export * from "./classTeacher.vue?vue&type=script&lang=js"
import style0 from "./classTeacher.vue?vue&type=style&index=0&id=eb9ee6f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb9ee6f0",
  null
  
)

export default component.exports